import PropTypes from 'prop-types';

const propTypes = {
  languageSelectorIsOpen: PropTypes.bool,
  setLanguageSelectorVisibility: PropTypes.func,
  user: PropTypes.object,
  changeLanguage: PropTypes.func,
  dispatch: PropTypes.func,
  languageOptions: PropTypes.array,
  title: PropTypes.string,
};

const defaultProps = {
  languageSelectorIsOpen: false,
  setLanguageSelectorVisibility: () => {},
  user: {},
  changeLanguage: () => {},
  dispatch: () => {},
  languageOptions: [],
  title: '',
};

export { propTypes, defaultProps };
